import * as React from 'react';
import { TristateBoolean } from '../../../../../react-commons/enums/tristateBoolean';
import { ControlledInputs } from '../../../../../react-commons/utils/read-only-inputs/controlledInputs';
import { getEnumFormatter } from '../../../resource/enumerations/utils/getEnumFormatter';
import { Setting, SettingClass, UpdatedSetting } from '../../../resource/resource-base/settings/types';
import { PropertyValidationInformation } from '../../util/PropertyValidationInformation';
import { ControlledPropertyInputs } from '../base/property-bases/read-only/ControlledPropertyInputs';

export const BasePropertySettingComponent= ({ setting, onChange, disabled = false, propertyValidationInformation }: {
    setting: Setting;
    onChange: (setting: UpdatedSetting) => void;
    disabled?: boolean;
    propertyValidationInformation: PropertyValidationInformation;
}) => {
    return (
        <>
            {/* TODO: check nullability everywhere*/}
            {setting.settingDefinition.settingClass === SettingClass.BOOLEAN ?
                // TODO: check checkbox checking in  before finish bug
                <ControlledPropertyInputs.Boolean
                    readOnly={disabled}
                    value={setting.value as boolean}
                    onChange={(value) => {
                        onChange({
                            identifier: setting.settingDefinition.identifier,
                            value,
                        });
                    }}
                    propertyValidationInformation={propertyValidationInformation}
                />
            : setting.settingDefinition.settingClass === SettingClass.STRING ?
                <ControlledPropertyInputs.String
                    readOnly={disabled}
                    value={setting.value as string}
                    nullable={false}
                    onChange={(newValue) =>
                        onChange({ identifier: setting.settingDefinition.identifier, value: newValue })
                    }
                    propertyValidationInformation={propertyValidationInformation}
                />
            : setting.settingDefinition.settingClass === SettingClass.INTEGER ?
                <ControlledPropertyInputs.Number
                    readOnly={disabled}
                    value={setting.value as number}
                    nullable={false}
                    onChange={(newValue) =>
                        onChange({ identifier: setting.settingDefinition.identifier, value: newValue })
                    }
                    propertyValidationInformation={propertyValidationInformation}
                />
                // : setting.settingDefinition.settingClass === SettingClass.ENUM ?
                //     <ControlledInputs.Enum
                //         label={setting.settingDefinition.identifier
                //             .split('_')
                //             .map((word) => word.charAt(0) + word.slice(1).toLowerCase())
                //             .join(' ')}
                //         readOnly={disabled}
                //         clearable={false}
                //         enumType={AllowedProjectArchetype}
                //         enumFormatter={getEnumFormatter(AllowedProjectArchetype)}
                //         value={setting.value as AllowedProjectArchetype}
                //         onChange={(newValue) =>
                //             onChange({
                //                 identifier: setting.settingDefinition.identifier,
                //                 value: newValue,
                //             })
                //         }
                //     />
            :   setting.settingDefinition.settingClass === SettingClass.TRISTATE_BOOLEAN && (
                    <ControlledInputs.Enum
                        label={setting.settingDefinition.identifier
                            .split('_')
                            .map((word) => word.charAt(0) + word.slice(1).toLowerCase())
                            .join(' ')}
                        readOnly={disabled}
                        value={setting.value as TristateBoolean}
                        nullable={false}
                        enumType={TristateBoolean}
                        enumFormatter={getEnumFormatter(TristateBoolean)}
                        onChange={(newValue) =>
                            onChange({ identifier: setting.settingDefinition.identifier, value: newValue })
                        }
                    />
                )
            }
        </>
    );
};
